import {createStore} from "vuex";

import party from "@/store/party-state";

export default createStore({
    modules: {
        party
    }
});